module.exports = __webpack_public_path__ + "img/lassen_header_small.c879ccd1.webp";